import { axios } from './axios';
import { handleErrors } from './utils';

export function getCustomValidations() {
    return new Promise((resolve, reject) => {
        axios
            .get(`customvalidations/v1`)
            .then(({ data }) => {
                resolve(data);
            })
            .catch(handleErrors(reject));
    });
}
